import { AppAction, PageFilter } from '../../../../state/app';

export const FETCH_PENDING_APPROVAL_SAMPLE_DEV_WL_LIST =
  'FETCH_PENDING_APPROVAL_SAMPLE_DEV_WL_LIST';

export const fetchPendingApprovalSampleDevWlList = (paging: PageFilter): AppAction => {
  return {
    type: FETCH_PENDING_APPROVAL_SAMPLE_DEV_WL_LIST,
    payload: {
      filters: { 'HasResponded.EqualsTo': 'false' },
      paging,
    },
  };
};
